import { useDemo } from "../zustand/DemoZustand";
import { Textmarker, Warnung } from "./Symbole";
import { fassungslage } from "../hilfen/auswertung";
import { useChat } from "../zustand/ChatZustand";

/*
  Der Hinweis, dass die Verwaltung eine Vorlage nachgetauscht hat.

  Warum das kein Nebensatz sein darf: Ein Fraktionsmitglied hat abends eine
  Vorlage gelesen, Stellen markiert und darüber diskutiert. Kommt zwei Wochen
  später eine neue Fassung, ist all das an einen Text gebunden, den es so nicht
  mehr gibt. Verschwiege die Software das, ginge jemand mit Notizen zur
  falschen Fassung in die Sitzung — und merkt es erst dort.

  Deshalb wird nichts automatisch umgehängt. Was die Fraktion erarbeitet hat,
  bleibt bei der Fassung, zu der es gehört, und die Anwendung sagt, wo es
  liegt. Der Weg dorthin ist immer nur einen Knopfdruck weit.

  Bewusst ohne Signalfarbe: Zustände dürfen in dieser Anwendung nie allein über
  Farbe erkennbar sein. Die Aussage steht im Text.
*/

export default function Fassungshinweis({ vorlage, aufFassung }) {
  const { stammdaten, zustand, ich } = useDemo();
  /*
    Die Beiträge stehen bei Matrix, die Markierungen im Browser. Für die
    Zählung müssen beide zusammen betrachtet werden — sonst stünde am
    Fassungswechsel dauerhaft „0 Beiträge“, obwohl welche da sind.
  */
  const chat = useChat();
  const lage = fassungslage(
    stammdaten,
    { ...zustand, nachrichten: chat.nachrichten },
    ich.id,
    vorlage
  );

  if (!lage) return null;

  const { istNeuere, andere, markierungen, beitraege } = lage;

  return (
    <div className="fassung">
      <p className="fassung__kopf">
        <Warnung groesse={18} />
        {istNeuere ? (
          <span>
            Die Verwaltung hat diese Vorlage <strong>nachgetauscht</strong>. Du siehst
            Fassung {vorlage.fassung}.
          </span>
        ) : (
          <span>
            Das ist <strong>nicht mehr die aktuelle Fassung</strong>. Beraten wird
            Fassung {andere.fassung}.
          </span>
        )}
      </p>

      <p className="fassung__text">
        {istNeuere ? (
          <>
            Was ihr an Fassung {andere.fassung} erarbeitet habt, ist nicht verloren — es
            steht dort weiter. Umgehängt wird nichts: Die Textstellen der alten Fassung
            gibt es in dieser hier nicht mehr an derselben Stelle.
          </>
        ) : (
          <>
            Diese Fassung bleibt samt allem, was daran hängt, erhalten. Für die Sitzung
            zählt aber die neue.
          </>
        )}
      </p>

      {(markierungen > 0 || beitraege > 0) && (
        <p className="fassung__zahlen">
          <Textmarker groesse={16} />
          An Fassung {andere.fassung} hängen{" "}
          {markierungen > 0 && (
            <strong>
              {markierungen} {markierungen === 1 ? "Markierung" : "Markierungen"}
            </strong>
          )}
          {markierungen > 0 && beitraege > 0 && " und "}
          {beitraege > 0 && (
            <strong>
              {beitraege} {beitraege === 1 ? "Beitrag" : "Beiträge"} mit Zitat
            </strong>
          )}
          .
        </p>
      )}

      {andere.dateiId && aufFassung && (
        <button
          className="knopf knopf--zurueckhaltend"
          onClick={() => aufFassung(andere.dateiId)}
        >
          Fassung {andere.fassung} öffnen
        </button>
      )}
    </div>
  );
}
